import { db, functions } from "../firebase";
import {
  doc,
  setDoc,
  increment,
  updateDoc,
  collection,
  query,
  where,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";

export const updateInvitedProspects = async (inviteEmail, invitedByEmail) => {
  try {
    if (!inviteEmail || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(inviteEmail)) {
      throw new Error("Invalid or missing inviteEmail");
    }
    if (!invitedByEmail || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(invitedByEmail)) {
      throw new Error("Invalid or missing invitedByEmail");
    }

    const invitedProspectsRef = collection(db, "invitedProspects");
    const q = query(
      invitedProspectsRef,
      where("inviteEmail", "==", inviteEmail)
    );
    const querySnapshot = await getDocs(q);

    const currentTimestamp = Date.now(); // Unix epoch timestamp in milliseconds

    if (!querySnapshot.empty) {
      // Document exists, update invitedByEmails if needed
      const docSnapshot = querySnapshot.docs[0];
      const docData = docSnapshot.data();
      const invitedByEmails = docData.invitedByEmails || [];

      if (!invitedByEmails.includes(invitedByEmail)) {
        await updateDoc(docSnapshot.ref, {
          invitedByEmails: [...invitedByEmails, invitedByEmail],
          updatedAt: currentTimestamp, // Use epoch timestamp
        });
        console.log(
          `Added ${invitedByEmail} to ${inviteEmail}'s invitedByEmails`
        );
      } else {
        console.log(
          `${invitedByEmail} already in ${inviteEmail}'s invitedByEmails`
        );
      }
      return { success: true, docId: docSnapshot.id };
    } else {
      // No document, create a new one
      const newDocRef = doc(invitedProspectsRef); // Auto-generated ID
      const newDocData = {
        inviteEmail,
        invitedByEmails: [invitedByEmail],
        createdAt: currentTimestamp, // Use epoch timestamp
        updatedAt: currentTimestamp, // Use epoch timestamp
      };
      await setDoc(newDocRef, newDocData);
      console.log(
        `Created new document for ${inviteEmail} with ID: ${newDocRef.id}`
      );
      return { success: true, docId: newDocRef.id };
    }
  } catch (error) {
    console.error("Error updating invited prospects:", error.message);
    throw error;
  }
};

export const updateInviteCount = async (count) => {
  try {
    const auth = getAuth();
    const userId = auth.currentUser?.uid;
    if (!userId) {
      throw new Error("No authenticated user found");
    }
    const userRef = doc(db, "user", userId);
    await updateDoc(userRef, {
      inviteCount: increment(count),
    });
    console.log(`Updated inviteCount by ${count} for user ${userId}`);
  } catch (error) {
    console.error("Error updating inviteCount:", error.message);
    throw error;
  }
};

export const sendManualEmailInvites = async (emails, senderName) => {
  try {
    const sendInvites = httpsCallable(functions, "handleManualEmailInvites");
    const response = await sendInvites({ emails, senderName });
    console.log("Manual email invites sent:", response.data);
    return response.data; // { message: "Invites successfully sent", sentCount: X }
  } catch (error) {
    console.error("Error sending manual email invites:", error.message);
    throw error;
  }
};
